// Content of the live sales demo («Modo demo» in Settings, Bronze's own client only): for each kind
// of restaurant the presenter can pick, three orders pending their photo. EDIT HERE ONLY — products,
// order numbers, platforms and which item the first analysis reports as missing. Everything is
// fictitious and brand-free: no real order, no real customer, no third-party brand.
//
// `labelKey` is the i18n key of the category's name (src/i18n-messages.js); product names are data
// and stay in Spanish, like a Spanish restaurant's ticket.
// `items` uses OrderItem's shape minus the ids (added when the order is built):
//   { icon: ':shortcode:', quantity, name, items?: [sub-items] }
// `firstMissing` is what the FIRST analysis of that order says is missing, in the raw
// /item-comparison shape (_buildAnalysisResult maps it into the real «Falta X» popup).
// Every later analysis of the same order comes back correct.

// Ticket group for the products that are not part of a menu (sides, sauces, desserts...).
export const looseGroupName = 'Complementos';

export const DEFAULT_CATEGORY = 'burger';

export const categories = [
    {
        id: 'pizza',
        labelKey: 'message.demoCategoryPizza',
        icon: ':pizza:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100517284',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':pizza:',
                        quantity: 1,
                        name: 'Menú Pizza Mediana',
                        items: [
                            { icon: ':pizza:', quantity: 1, name: 'Pizza Barbacoa mediana' },
                            { icon: ':bread:', quantity: 1, name: 'Pan de ajo' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de cola 50 cl' },
                        ],
                    },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Alitas de pollo 6 uds' },
                ],
                firstMissing: {
                    group_name: 'Alitas de pollo',
                    icon: 'chicken',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Alitas de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'C4M8R',
                createdMinAgo: 4,
                items: [
                    { icon: ':pizza:', quantity: 2, name: 'Pizza Margarita familiar' },
                    { icon: ':bread:', quantity: 1, name: 'Palitos de queso 8 uds' },
                    { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de naranja 1,5 L' },
                ],
                firstMissing: {
                    group_name: 'Bebida',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Refresco de naranja 1,5 L'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '61427',
                createdMinAgo: 6,
                items: [
                    { icon: ':pizza:', quantity: 1, name: 'Pizza Cuatro Quesos mediana' },
                    { icon: ':pizza:', quantity: 1, name: 'Pizza Pepperoni mediana' },
                    { icon: ':ice_cream:', quantity: 1, name: 'Helado de vainilla 500 ml' },
                ],
                firstMissing: {
                    group_name: 'Postre',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Helado de vainilla 500 ml'],
                },
            },
        ],
    },
    {
        id: 'burger',
        labelKey: 'message.demoCategoryBurger',
        icon: ':hamburger:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100482913',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 1,
                        name: 'Menú Hamburguesa Clásica',
                        items: [
                            { icon: ':hamburger:', quantity: 1, name: 'Hamburguesa Clásica' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas medianas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de cola mediano' },
                        ],
                    },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Nuggets de pollo 6 uds' },
                    { icon: ':bowl_with_spoon:', quantity: 1, name: 'Salsa barbacoa' },
                ],
                firstMissing: {
                    group_name: 'Nuggets de pollo',
                    icon: 'chicken',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Nuggets de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'B7K2Q',
                createdMinAgo: 4,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 1,
                        name: 'Menú Pollo Crujiente',
                        items: [
                            { icon: ':hamburger:', quantity: 1, name: 'Hamburguesa de pollo crujiente' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas gajo medianas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Refresco de naranja mediano' },
                        ],
                    },
                    { icon: ':onion:', quantity: 1, name: 'Aros de cebolla 8 uds' },
                ],
                firstMissing: {
                    group_name: 'Bebida',
                    icon: 'cup_with_straw',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Refresco de naranja mediano'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '58213',
                createdMinAgo: 6,
                items: [
                    {
                        icon: ':hamburger:',
                        quantity: 2,
                        name: 'Menú Doble Queso',
                        items: [
                            { icon: ':hamburger:', quantity: 2, name: 'Hamburguesa doble con queso' },
                            { icon: ':french_fries:', quantity: 2, name: 'Patatas medianas' },
                            { icon: ':cup_with_straw:', quantity: 2, name: 'Refresco de cola zero mediano' },
                        ],
                    },
                    { icon: ':ice_cream:', quantity: 1, name: 'Sundae de chocolate' },
                ],
                firstMissing: {
                    group_name: 'Postre',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Sundae de chocolate'],
                },
            },
        ],
    },
    {
        id: 'chicken',
        labelKey: 'message.demoCategoryChicken',
        icon: ':poultry_leg:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100533871',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':poultry_leg:',
                        quantity: 1,
                        name: 'Cubo 8 piezas',
                        items: [
                            { icon: ':poultry_leg:', quantity: 8, name: 'Pieza de pollo frito' },
                            { icon: ':french_fries:', quantity: 2, name: 'Patatas grandes' },
                            { icon: ':cup_with_straw:', quantity: 2, name: 'Refresco de cola grande' },
                        ],
                    },
                    { icon: ':green_salad:', quantity: 1, name: 'Ensalada de col' },
                ],
                firstMissing: {
                    group_name: 'Ensalada de col',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Ensalada de col'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'D9P3W',
                createdMinAgo: 4,
                items: [
                    {
                        icon: ':poultry_leg:',
                        quantity: 1,
                        name: 'Menú Tiras Crujientes',
                        items: [
                            { icon: ':poultry_leg:', quantity: 5, name: 'Tiras de pollo crujiente' },
                            { icon: ':french_fries:', quantity: 1, name: 'Patatas medianas' },
                            { icon: ':cup_with_straw:', quantity: 1, name: 'Té helado mediano' },
                        ],
                    },
                    { icon: ':bowl_with_spoon:', quantity: 2, name: 'Salsa miel y mostaza' },
                ],
                firstMissing: {
                    group_name: 'Salsas',
                    icon: 'sauce',
                    missing_quantity: 1,
                    total_quantity: 2,
                    name: ['Salsa miel y mostaza'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '63390',
                createdMinAgo: 6,
                items: [
                    { icon: ':poultry_leg:', quantity: 1, name: 'Alitas picantes 9 uds' },
                    { icon: ':poultry_leg:', quantity: 1, name: 'Palomitas de pollo grandes' },
                    { icon: ':french_fries:', quantity: 1, name: 'Patatas grandes' },
                ],
                firstMissing: {
                    group_name: 'Patatas',
                    icon: 'french_fries',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Patatas grandes'],
                },
            },
        ],
    },
    {
        id: 'sushi',
        labelKey: 'message.demoCategorySushi',
        icon: ':sushi:',
        orders: [
            {
                deliveryPlatform: 'GLOVO',
                deliveryId: '100548126',
                createdMinAgo: 2,
                items: [
                    {
                        icon: ':sushi:',
                        quantity: 1,
                        name: 'Combo 24 piezas',
                        items: [
                            { icon: ':sushi:', quantity: 8, name: 'California roll' },
                            { icon: ':sushi:', quantity: 8, name: 'Maki de salmón' },
                            { icon: ':sushi:', quantity: 8, name: 'Nigiri variado' },
                        ],
                    },
                    { icon: ':dumpling:', quantity: 1, name: 'Gyozas de pollo 6 uds' },
                    { icon: ':bowl_with_spoon:', quantity: 2, name: 'Salsa de soja' },
                ],
                firstMissing: {
                    group_name: 'Gyozas',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Gyozas de pollo 6 uds'],
                },
            },
            {
                deliveryPlatform: 'UBER',
                deliveryId: 'F2T6H',
                createdMinAgo: 4,
                items: [
                    { icon: ':bento:', quantity: 1, name: 'Poke de salmón' },
                    { icon: ':green_salad:', quantity: 1, name: 'Edamame' },
                    { icon: ':green_salad:', quantity: 1, name: 'Ensalada wakame' },
                ],
                firstMissing: {
                    group_name: 'Entrantes',
                    icon: 'side',
                    missing_quantity: 1,
                    total_quantity: 2,
                    name: ['Ensalada wakame'],
                },
            },
            {
                deliveryPlatform: 'JUSTEAT',
                deliveryId: '67752',
                createdMinAgo: 6,
                items: [
                    { icon: ':sushi:', quantity: 1, name: 'Uramaki de atún picante 8 uds' },
                    { icon: ':fried_shrimp:', quantity: 1, name: 'Tempura de langostinos 5 uds' },
                    { icon: ':cake:', quantity: 1, name: 'Mochi de té verde 2 uds' },
                ],
                firstMissing: {
                    group_name: 'Postre',
                    icon: 'cake',
                    missing_quantity: 1,
                    total_quantity: 1,
                    name: ['Mochi de té verde 2 uds'],
                },
            },
        ],
    },
];

export function categoryById(id) {
    return categories.find((category) => category.id === id) || categories.find((c) => c.id === DEFAULT_CATEGORY);
}
